module.exports = __webpack_public_path__ + "static/media/bug.92af4e2c.svg";